module.exports = __webpack_public_path__ + "static/img/6394_phase_function_Paper_PointsHejduk_Prediction.cf67e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6394_phase_function_Paper_PointsHejduk_Prediction.png
// module id = DGTq
// module chunks = 0